<script setup lang="ts">
import SeperatorImg from '@/assets/components/categoryOffersBlock/separator.webp?url'
import bgImage from '@/assets/components/gameCategory/bg_pattern_green.webp?url'
import { offerDialog } from '@/components/shared/OfferDialog/OfferDialogCompose'

const { triggerApi, goadLoadAliveData, gameLoggedOrder, list, getRoutePathToGame } = gamesUtils
const { t } = useI18n()

// eslint-disable-next-line unused-imports/no-unused-vars
let isMounted = false
const { debounce } = tools

const loadAllDebounced = debounce(() => {
  goadLoadAliveData()
}, 500)
onMounted(() => {
  isMounted = true
  goadLoadAliveData()
  watch(triggerApi.triggerRef, () => {
    if (!offerDialog.value.visible) {
      loadAllDebounced()
    }
  })
})
onUnmounted(() => {
  isMounted = false
})
</script>

<template>
  <div
    class="3xl:py-20 bg-[#2f7c8b] bg-repeat-y"
    :style="`background-image: url('${bgImage}'); background-size: 100% auto;`"
  >
    <div
      v-for="(gameKey, index) in gameLoggedOrder"
      :key="gameKey"
      class="aspect-[1.42] bg-cover bg-no-repeat bg-top relative flex flex-col justify-between items-center text-white py-[5%] big:pt-[6%] big:py-[9%] 3xl:pt-[5%] 3xl:pb-[7%] min-h-64 big:max-h-[max(80vh,850px)] w-full 3xl:max-w-[clamp(600px,80vw,1200px)] mx-auto 3xl:shadow-2xl"
      :class="{
        '3xl:-translate-x-28': index % 2 === 0,
        '3xl:translate-x-28': index % 2 !== 0,
        '3xl:-mt-20': !!index
      }"
      :style="`background-image: url('${list?.[gameKey]?.gameBanner}');`"
    >
      <img
        :src="list?.[gameKey]?.logo"
        loading="lazy"
        :alt="t('index.gameLogoAlt')"
        class="max-w-[clamp(150px,40%,250px)] mini:max-w-[35%] origin-top cursor-pointer"
        :class="[list?.[gameKey]?.logoScale]"
        @click="$router.push(getRoutePathToGame(gameKey))"
      >
      <div class="text-center">
        <router-link
          :to="getRoutePathToGame(gameKey)"
        >
          <el-button
            color="#3ba6bc"
            class="text-white rounded-lg uppercase text-base mini:text-lg  xs:text-xl md:text-2xl big:text-3xl  font-black min-w-48 mini:min-w-64 xs:min-w-68 md:min-w-80 big:min-w-96 px-4 tracking-wide mb-5 h-10 xs:h-12 md:h-14 big:h-16"
            size="large"
          >
            {{ t('index.storeTitle', { gameName: list?.[gameKey]?.name ?? '' }) }}
          </el-button>
        </router-link>
      </div>
      <img
        alt=""
        class="w-full absolute lef-0 right-0 bottom-0 translate-y-1/2 z-10 3xl:hidden"
        :src="SeperatorImg"
      >
    </div>
  </div>
</template>

<style scoped></style>
